import React, { useState } from 'react';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const DownloadCostTemplateButton = _ref => {
  let {
    claim,
    loading,
    selectedProject
  } = _ref;
  const generateCostTemplate = () => {
    window.open("/api/claims/".concat(claim.id, "/claim_project_reports/").concat(selectedProject.id, "/claim_export_cost_template"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "mb-4",
    onClick: () => generateCostTemplate(),
    size: "md",
    loading: loading,
    variant: "info",
    iconPosition: "left",
    icon: "download"
  }, "Download Template"));
};
export default DownloadCostTemplateButton;